import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';

import { IAuroraState } from '@apps/aurora.state';
import { ListComponent } from '@common/extensions';
import * as fromRootStore from '@apps/root/store';

export abstract class ListChipsStateListenerComponent<T> extends ListComponent<T>
{
    public chipsState: Observable<boolean> = of(false);

    constructor (
        public store: Store<IAuroraState>
    )
    {
        super();

        this.chipsState = this.store.select(fromRootStore.getChipsStatus);
    }
}
